<template>
  <div>
    <div class="bg pic-full"></div>
    <!-- <warn class="warn" :home-lang="home"></warn> -->
    <div class="home">
      <header>
        <head-nav-bar class="head-nav-bar" :home-lang="home"></head-nav-bar>
        <head-nav-bar-mini
          class="head-nav-bar-mini"
          :home-lang="home"
        ></head-nav-bar-mini>
      </header>
      <main class="stake-main">
        <stake-introduction
          class="stake-introduction"
          :home-lang="home"
        ></stake-introduction>
        <stake-content class="stake-content" :home-lang="home"></stake-content>
        <stake-vote class="stake-vote" :home-lang="home"></stake-vote>
      </main>
      <footer>
        <foot-content class="foot-content" :home-lang="home"></foot-content>
      </footer>
    </div>
  </div>
</template>

<script>
import home from "@/lang/zh/home";
import Warn from "@/components/contents/warn";
import HeadNavBar from "@/components/Layouts/HeadNavBar";
import FootContent from "@/components/Layouts/FootContent";
import HeadNavBarMini from "@/components/Layouts/HeadNavBarMini";
import StakeIntroduction from "@/components/stake/stakeIntroduction";
import StakeContent from "@/components/stake/stakeContent";
import StakeVote from "@/components/stake/stakeVote";

export default {
  name: "Stake",
  components: {
    Warn,
    StakeContent,
    StakeIntroduction,
    HeadNavBar,
    HeadNavBarMini,
    FootContent,
    StakeVote,
  },
  data() {
    return {
      home: home,
    };
  },
};
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .stake-main {
    width: 10rem;
    margin: 0 auto 1.37rem;
    position: relative;
  }
}
@media screen and (max-width: 767px) {
  .stake-main {
    margin-bottom: 0.3rem;
  }
}
</style>
